"use client";

import { QuickAddBase } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddBase";
import { QuickAddProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import { QuickAddTrackingEventsContextProvider } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddTrackingEventsContext/QuickAddTrackingEventsContextProvider";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageNonPrimaryContentDeferRender } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPagePerformanceTrackingWrapper";
import React from "react";

export const DeferRenderedQuickAddBase = ({
  data,
}: {
  data: QuickAddProps;
}) => {
  useSearchPageNonPrimaryContentDeferRender();

  return (
    <QuickAddTrackingEventsContextProvider data={data}>
      <QuickAddBase data={data} />
    </QuickAddTrackingEventsContextProvider>
  );
};
